module.exports = __webpack_public_path__ + "static/img/customer-01.972e13c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/customer-01.png
// module id = ru5T
// module chunks = 2